<template>
  <iModal
    v-if="show"
    :close-on-backdrop="false"
    :close-on-escape="false"
    :close-on-secondary="false"
    :show-footer="false"
    :max-width="600"
    :content-height="80"
    scrollable
    title="Create a new variant"
    @close="$emit('close')"
  >
    <template #body>
      <iColumn>
        <iRow v-if="hasError" align="center">
          <iText variant="error">
            Error creating story variant, please contact support.
          </iText>
        </iRow>
        <iRow>
          <iSubHeading>{{ storyTitle || 'No title' }}</iSubHeading>
        </iRow>
        <iRow align="center">
          <iStyledCard
            v-for="variant in STORY_VARIANT_TYPES"
            :key="variant.value"
            :description="variant.description"
            :splash-image="variant.splash"
            :splash-image-max-height="100"
            :title="variant.label"
            :max-width="270"
            width="fill"
            :disabled="isCreatingStoryVariant"
          >
            <template #footer>
              <iButton
                variant="secondary"
                width="fill"
                loading-spinner-position="inside"
                :disabled="isCreatingStoryVariant"
                :is-loading="creatingVariantType === variant.value && isCreatingStoryVariant"
                @click="createVariant(variant.value)"
              >
                Create
              </iButton>
            </template>
          </iStyledCard>
        </iRow>
      </iColumn>
    </template>
  </iModal>
</template>

<script>
import { STORY_VARIANT_TYPES } from "@/constants/story-variant-type-constants";
import { mapActions, mapState } from "pinia";
import { useStoryStore } from "%/stores/story-store";
import { usePublicationStore } from "@/stores/publication-store";

export default {
  name: "CreateVariantsModal",
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    storyTitle: {
      type: String,
      required: false,
      default: "No title",
    },
    storyId: {
      type: Number,
      required: true,
    },
  },
  emits: ["close"],
  data() {
    return {
      STORY_VARIANT_TYPES,
      creatingVariantType: null,
      hasError: false,
    };
  },
  computed: {
    ...mapState(useStoryStore, [
      "isCreatingStoryVariant",
    ]),
    ...mapState(usePublicationStore, [
      "publicationId",
    ]),
  },
  methods: {
    ...mapActions(useStoryStore, ["createStoryVariant"]),
    createVariant(variantType) {
      this.creatingVariantType = variantType;
      this.createStoryVariant(this.storyId, variantType, this.publicationId, data => {
        this.creatingVariantType = null;
        this.hasError = false;
        document.location.href = `/stories/editor?story_id=${data.storyId}`;
      }, () => {
        this.creatingVariantType = null;
        this.hasError = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
